/*
 * Endless practice — placeholder for FR-PRAC-01 (M4).
 *
 * Mirrors the level-intro stub: gives the "Endless Practice" entry on the
 * level-select screen a real navigation target. FR-PRAC-01 will replace this
 * with the real endless-mode session.
 */

import { navigate } from '../router';

export function renderPractice(mount: HTMLElement): void {
  const card = document.createElement('article');
  card.className = 'card card--elevated';

  const tag = document.createElement('span');
  tag.className = 'tag tag--solid';
  tag.textContent = 'Coming in M4';
  card.appendChild(tag);

  const heading = document.createElement('h1');
  heading.style.marginTop = 'var(--space-4)';
  heading.textContent = 'Endless practice';
  card.appendChild(heading);

  const body = document.createElement('p');
  body.style.marginTop = 'var(--space-3)';
  body.style.color = 'var(--color-text-warm)';
  body.textContent = 'FR-PRAC-01 will replace this stub with the real endless-mode loop.';
  card.appendChild(body);

  const back = document.createElement('button');
  back.type = 'button';
  back.className = 'btn btn--secondary';
  back.style.marginTop = 'var(--space-5)';
  back.textContent = 'Back to levels';
  back.addEventListener('click', () => {
    navigate('');
  });
  card.appendChild(back);

  mount.appendChild(card);
}
